import { render, staticRenderFns } from "./limit-batch-application.vue?vue&type=template&id=739e5132&scoped=true"
import script from "./limit-batch-application.vue?vue&type=script&lang=js"
export * from "./limit-batch-application.vue?vue&type=script&lang=js"
import style0 from "./limit-batch-application.vue?vue&type=style&index=0&id=739e5132&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739e5132",
  null
  
)

export default component.exports